"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasketItemRoot = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("../constants");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div', {
  shouldForwardProp: prop => prop !== 'ownerState' // Add this option
})(({
  ownerState: {
    isBundle,
    isBundleItem,
    isSmall
  },
  theme
}) => ({
  position: 'relative',
  boxSizing: 'content-box',
  width: '100%',
  overflow: 'hidden',
  display: 'grid',
  gridTemplateColumns: `${_constants.XS_IMAGE_SIZE}px auto`,
  padding: theme.spacing(4, 1),
  margin: theme.spacing(0, -1),
  gridTemplateRows: 'auto auto auto',
  gridTemplateAreas: `
  'image product'
  'image numbers'
  'actions actions'`,
  ...(isBundleItem && {
    gridTemplateRows: 'auto auto',
    gridTemplateAreas: `
    'image product'
    'image actions'`
  }),
  ...(isBundle && {
    gridTemplateRows: 'auto auto auto auto',
    gridTemplateAreas: `
    'image product'
    'image numbers'
    'actions actions'
    'bundle bundle'`
  }),
  columnGap: _constants.XS_COLUMN_GAP,
  rowGap: theme.spacing(3),
  ...(!isSmall && {
    [theme.breakpoints.up('sm')]: {
      maxWidth: '100%'
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: '100%',
      gridTemplateColumns: `${_constants.MD_IMAGE_SIZE}px auto minmax(200px, max-content)`,
      gridTemplateRows: 'auto auto',
      gridTemplateAreas: `
      'image product numbers'
      'image actions actions'`,
      ...(isBundle && {
        gridTemplateRows: 'auto auto auto',
        gridTemplateAreas: `
      'image product numbers'
      'image actions actions'
      'bundle bundle bundle'`
      }),
      columnGap: _constants.MD_COLUMN_GAP
    }
  })
}));
const Loader = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'grid',
  alignContent: 'center',
  justifyContent: 'center',
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backdropFilter: 'blur(2px)',
  WebkitBackdropFilter: 'blur(2px)',
  background: (0, _mui.alpha)(theme.palette.background.paper, 0.85)
}));
const BasketItemRoot = ({
  children,
  isBundle,
  isBundleItem,
  itemTestId,
  isSmall,
  isLoading
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
  inert: isLoading ? '' : undefined,
  "data-testid": itemTestId,
  ownerState: {
    isBundle,
    isBundleItem,
    isSmall: isSmall ?? false
  },
  className: _constants.BASKET_ITEM_IDENTIFIER,
  children: [children, isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(Loader, {
    "data-testid": `${itemTestId}-loading`,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.CircularProgress, {})
  }) : null]
});
exports.BasketItemRoot = BasketItemRoot;
